import { randomUUID } from '@openx/utils/lib/uuid.ts';
import { type ComponentProps, useEffect } from 'react';
import { CSVLink } from 'react-csv';
import { createRoot } from 'react-dom/client';

type CSVLinkProps = ComponentProps<typeof CSVLink>;

type CSVLinkConfig = {
  data: CSVLinkProps['data'];
  filename: string;
  headers?: CSVLinkProps['headers'];
};

type CSVLinkRenderProps = {
  onRendered: () => void;
  config: CSVLinkConfig;
};

const CSVLinkRender = ({ onRendered, config }: CSVLinkRenderProps) => {
  useEffect(() => {
    onRendered();
  }, [onRendered]);

  return <CSVLink {...config} />;
};

export const csvDownload = (config: CSVLinkConfig) => {
  const containerId = randomUUID();
  const container = document.createElement('div');
  container.id = containerId;
  document.body.appendChild(container);
  const root = createRoot(container);
  root.render(
    <CSVLinkRender
      onRendered={() => {
        const link = container.children[0] as HTMLAnchorElement;
        link?.click();
        container.remove();
      }}
      config={config}
    />
  );
};
